import { getCache } from "./cache";
import { apiBaseUrl } from "./config";

const baseUrl = `${apiBaseUrl}/products`;

/**
 * Get the list of membership products. If outputFormat is 'raw', the response will include all the product details as stored in the database, including the Stripe product and price IDs.
 * If outputFormat is 'json', the response will be a simplified version of the products, with only the information needed for display and ordering.
 * 
 * @param {'json' | 'raw'} outputFormat 
 * @returns {Promise<Array>}
 */
async function getMembershipProducts(outputFormat = 'json') {
  let url = `${baseUrl}/memberships`;
  if (outputFormat === 'raw') {
    url += '?raw=true';
  }
  const r = await fetch(url);
  const data = await r.json();
  return data;
}

/**
 * Get the list of libro products. If outputFormat is 'raw', the response will include all the product details as stored in the database, including the Stripe product and price IDs.
 * If outputFormat is 'json', the response will be a simplified version of the products, with only the information needed for display and ordering.
 * 
 * @param {'json' | 'raw'} outputFormat 
 * @returns {Promise<Array>}
 */
async function getLibroProducts(outputFormat = 'json') {
  let url = `${baseUrl}/libros`;
  if (outputFormat === 'raw') {
    url += '?raw=true';
  }
  const r = await fetch(url);
  const data = await r.json();
  return data;
}

/**
 * Make a POST request to create a new product if productData does not include a product_id,
 * or a PUT request to update an existing product if productData includes a product_id.
 * The function returns the response from the API, which should include the created or updated product details.
 * @param {{
 *  product_id?: number,
 *  product_name: string,
 *  product_description: string,
 *  product_type: 'libro' | 'membresia',
 *  price: number,
 *  profile_type?: 1 | 2 | 3,
 *  etapa?: string,
 *  active?: boolean,
 *  stripe_product_id?: string,
 *  stripe_price_id?: string
 * }} productData 
 * @returns 
 */
async function createOrUpdateProduct(productData) {
  const method = productData.product_id ? 'PUT' : 'POST';
  const url = `${baseUrl}/${productData.product_id || ''}`;
  const r = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getCache('token')}`
    },
    body: JSON.stringify(productData)
  });
  const data = await r.json();
  return data;
}

export {
  getMembershipProducts,
  getLibroProducts,
  createOrUpdateProduct
};
